module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "企业授权信息",
      "type": "warning",
      "description": "请勿随意改动!通讯录应用对应的该企业下的应用id,随意改动会导致系统出错.",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auth_corpid",
      "label": "企业id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "企业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "permanent_code",
      "label": "授权code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "suite_id",
      "label": "第三方应用id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_emp",
      "label": "调用通讯录"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_emp == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("是")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "employee_agent",
      "label": "通讯录应用"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.update_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleEdit
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.qyconfigForm,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "是否启用"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "0否,1是"
      },
      model: {
        value: (_vm.qyconfigForm.is_emp),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "is_emp", $$v)
        },
        expression: "qyconfigForm.is_emp"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "通讯录应用"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "通讯录应用"
      },
      model: {
        value: (_vm.qyconfigForm.employee_agent),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "employee_agent", $$v)
        },
        expression: "qyconfigForm.employee_agent"
      }
    })], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.editVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87c5c278", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87c5c278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/workwx/permanent.vue
// module id = 2875
// module chunks = 0